import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getDaftarKatalog = createAsyncThunk('/daftar_katalog/content', async (nopage) => {
    const userId = localStorage.getItem("userId");
    
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/daftarkatalog/${userId}?page=${nopage}`, {})
    
    return response.data;
})

export const daftarkatalogSlice = createSlice({
    name: 'daftar_katalog',
    initialState: {
        isLoading: false,
        daftar_katalog : []
    },

    /*extraReducers: {
        [getDaftarKatalog.pending]: state => {
			state.isLoading = true
		},
        [getDaftarKatalog.fulfilled]: (state, action) => {
            state.daftar_katalog = action.payload.data
			state.isLoading = false
		},
        [getDaftarKatalog.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {           
        builder         
        .addCase(getDaftarKatalog.pending, (state) => {
            state.isLoading = true;
        })                   
        .addCase(getDaftarKatalog.fulfilled, (state, action) => {
            state.daftar_katalog = action.payload.data;
            state.isLoading = false;
        })                              
        .addCase(getDaftarKatalog.rejected, (state) => {
            state.isLoading = false;
        })                   
    }   
})


export default daftarkatalogSlice.reducer